import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  APPROVAL_ACTION_UTILITY_REQUEST,
  APPROVAL_ACTION_UTILITY_REQUEST_SUCCESS,
  APPROVAL_ACTION_UTILITY_REQUEST_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* approvalActionUtilityRequest({ payload }) {

      const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

  try {
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/approval-action`,
      method: 'POST',
      data: payload,
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message || 'Action completed successfully');
      yield put({ type: APPROVAL_ACTION_UTILITY_REQUEST_SUCCESS, payload: response?.data });
    } else {
      const msg = response?.response?.data?.message || 'Action failed';
      cogoToast.error(msg);
      yield put({ type: APPROVAL_ACTION_UTILITY_REQUEST_ERROR, payload: msg });
    }
  } catch (error) {
    cogoToast.error('Action failed');
    yield put({ type: APPROVAL_ACTION_UTILITY_REQUEST_ERROR, payload: error });
  }
}

export function* watchApprovalActionUtilityRequest() {
  yield takeLatest(APPROVAL_ACTION_UTILITY_REQUEST, approvalActionUtilityRequest);
}

function* approvalActionUtilityRequestSaga() {
  yield all([fork(watchApprovalActionUtilityRequest)]);
}

export default approvalActionUtilityRequestSaga;
